import {
  alpha,
  Box,
  Button,
  IconButton,
  Stack,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import Iconify from "../iconify/Iconify";

const VIEW_DESCRIPTIONS = {
  plan: "Standorte filtern, Kalender navigieren und freie Trainings auswählen.",
  summary: "Deine gebuchten Trainings und Stunden im Überblick.",
  "admin-summary":
    "Trainer auswählen und gebuchte Trainings für die Abrechnung prüfen.",
};

export default function TrainerPageHeader({
  pageView,
  onChangeView,
  canViewAdminSummary = false,
}) {
  const theme = useTheme();
  const showTextButtons = useMediaQuery(theme.breakpoints.up("lg"));
  const getButtonStyles = (isActive) => ({
    border: "1px solid",
    borderColor: isActive ? "primary.main" : "divider",
    borderRadius: 2,
    backgroundColor: isActive
      ? alpha(theme.palette.primary.main, 0.08)
      : "transparent",
    color: isActive ? "primary.main" : "text.secondary",
  });

  return (
    <Stack
      direction="row"
      alignItems="flex-start"
      justifyContent="space-between"
      spacing={1}
      sx={{ pt: { xs: 1, md: 2 } }}
    >
      <Box>
        <Typography variant="h4" sx={{ fontWeight: 700 }}>
          Trainer-Plan
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>
          {VIEW_DESCRIPTIONS[pageView] || VIEW_DESCRIPTIONS.plan}
        </Typography>
      </Box>

      <Stack direction="row" spacing={0.5}>
        {showTextButtons ? (
          <>
            <Button
              size="medium"
              startIcon={
                <Iconify icon="mdi:calendar-month-outline" width={20} />
              }
              onClick={() => onChangeView("plan")}
              sx={getButtonStyles(pageView === "plan")}
            >
              Trainingsplan
            </Button>
            <Button
              size="medium"
              startIcon={
                <Iconify icon="mdi:clipboard-text-clock-outline" width={20} />
              }
              onClick={() => onChangeView("summary")}
              sx={getButtonStyles(pageView === "summary")}
            >
              Meine Trainings
            </Button>
            {canViewAdminSummary ? (
              <Button
                size="medium"
                startIcon={<Iconify icon="mdi:account-group-outline" width={20} />}
                onClick={() => onChangeView("admin-summary")}
                sx={getButtonStyles(pageView === "admin-summary")}
              >
                Trainerübersicht
              </Button>
            ) : null}
          </>
        ) : (
          <>
            <Tooltip title="Trainingsplan">
              <IconButton
                size="small"
                onClick={() => onChangeView("plan")}
                sx={getButtonStyles(pageView === "plan")}
              >
                <Iconify icon="mdi:calendar-month-outline" width={20} />
              </IconButton>
            </Tooltip>
            <Tooltip title="Meine Trainings">
              <IconButton
                size="small"
                onClick={() => onChangeView("summary")}
                sx={getButtonStyles(pageView === "summary")}
              >
                <Iconify icon="mdi:clipboard-text-clock-outline" width={20} />
              </IconButton>
            </Tooltip>
            {canViewAdminSummary ? (
              <Tooltip title="Trainerübersicht">
                <IconButton
                  size="small"
                  onClick={() => onChangeView("admin-summary")}
                  sx={getButtonStyles(pageView === "admin-summary")}
                >
                  <Iconify icon="mdi:account-group-outline" width={20} />
                </IconButton>
              </Tooltip>
            ) : null}
          </>
        )}
      </Stack>
    </Stack>
  );
}
